// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Model for Case-to-Document relationship
*/
export class TrialcardCaseV3ModelsCaseDocumentRelationshipModel {
    'documentId'?: number;
    'comment'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TrialcardCaseV3ModelsCaseDocumentRelationshipModel>> = [
        {
            "name":     "documentId",
            "baseName": "documentId",
            "type":     "number"
        },
        {
            "name":     "comment",
            "baseName": "comment",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TrialcardCaseV3ModelsCaseDocumentRelationshipModel.attributeTypeMap;
    }
}
